import useStore from '@/store'

export const getCameraType = async(sn) => {
    try {
    const url = "http://34.95.23.58:8080/telemetry/" + sn + "/key/camera_type"
    const token = localStorage.getItem("x-auth-token")
    const headers = {
        "x-auth-token": token,
        "Content-Type": "application/json"
    }
    const response = await fetch(url, {headers})
    const data = await response.json()
    
        const store = useStore()    
        const vt = data["data"]
        store.lentSelection = vt
        console.warn("lentSelection", store.lentSelection)
        return data
    } catch (error){
        console.warn(error)
        return ""
    }
}

